import React, { useState, useContext, useEffect, useRef } from "react";
import { AppContext } from "../Provider/Provider";

import CategoriaCard from './CategoriaCardComponent';
import InputCard from './InputCardComponent';
import Medidor from './Medidor/MedidorComponent';

const Inputs = ({ onClick, data }) => {
  const [arrayCategorias, setArrayCategorias] = useState([]);

  // Nombre Categoria desde categoriaCard onClick
  const [cateNamefromCard, setCateNamefromCard] = useState("Climatización");

  const [arrayElectrodomesticos, setArrayElectrodomesticos] = useState([]);

  const [arrayCantidad, setArrayCantidad] = useState([]);

  const [arrayUsoDiario, setArrayUsoDiario] = useState([]);

  const [valoresConsumoState, setValoresConsumoState] = useContext(AppContext);

  const scrollableI = useRef();

  if (data !== undefined && data.length !== 0) {

    if (Object.keys(arrayCategorias).length === 0) {
      setArrayCategorias(data["Categorías"]);

      // Setea los electrodomesticos para la categoría recibida
      setArrayElectrodomesticos(data["Categorías"][cateNamefromCard]);
    }

    if (Object.keys(arrayCantidad).length === 0) {
      setArrayCantidad(data["Cantidad"]);
    }

    if (Object.keys(arrayUsoDiario).length === 0) {
      setArrayUsoDiario(data["Uso Diario"]);
    }
  }

  var cat = [];
  if (arrayCategorias !== undefined) {
    // Obtiene los nombres de la categorías para mostrarlos en CategoriaCard
    cat = Object.keys(arrayCategorias); 
  }


  function enableButton() {
    if(valoresConsumoState.TotalkWhBim == 0)
      return true;
    else
      return false;
  }


  function handleClick(event) {
    onClick(event.target.verResultados);
    let localObj = valoresConsumoState;
    localObj.disableDropdown = false;
    setValoresConsumoState(localObj);

  }

 
  function saveNameOnClick(item) {
    let localObj = valoresConsumoState;
    
    setCateNamefromCard(item);
    setArrayElectrodomesticos(data["Categorías"][item]);

    localObj.clearDropdown = true;
    
    localObj.disableDropdown = false;
    setValoresConsumoState(localObj);

  }

  const scrollToElement = () => scrollableI.current.scrollIntoView();
  
  useEffect(() => {
    scrollToElement();
     
  },[]);

  return (
      <div ref={scrollableI} className={"m-0.5 md:mt-4 md:mx-6"}>
        <div className={"grid grid-cols-1 md:grid-cols-2"}>
          <div className={""}>
            <span className={"rounded-full px-4 mr-2 bg-dpecGreen text-white text-sm p-1 leading-none items-center"}>
              1
            </span>
            <span className={"m-2 | text-sm font-medium"}>
              Seleccioná dentro de cada categoría los electrodomésticos que utilizás, indicando cantidad y horas de uso diario.
            </span>
          </div>
        </div>
        <div className={"grid grid-cols-1 md:grid-cols-2"}>
          <div className={"mt-4 grid grid-cols-2 gap-x-2 gap-y-4 md:gap-4"}>
            {cat.map((cate, index) => (
              <div key={index + 1}>
                <CategoriaCard
                  name={cate}
                  getCateName={(itemName) => saveNameOnClick(itemName)}
                  currentCateName={cateNamefromCard}
                />
              </div>
            ))}
          </div>
          <div className={"mx-0.5 my-6 md:m-6 md:mt-4"}>
            <InputCard
              nombreCategoria={cateNamefromCard}
              electrodomesticos={arrayElectrodomesticos}
              cantidad={arrayCantidad}
              usoDiario={arrayUsoDiario}
            />
          </div>
        </div>
      <div className={"w-full | grid grid-cols-1 md:grid-cols-2 gap-4 | mb-20 md:mb-0"}>
        <div className={"grid"}>
          <div className={"mt-1 mb-4 md:mt-8 | text-sm font-medium"}>
            <div className={""}>
              <div>
                <span className={"rounded-full px-4 mr-2 bg-dpecGreen text-white text-sm p-1 leading-none items-center"}>
                  2
                </span>
                <span className={"my-2 | text-sm font-medium"}>
                  Presioná el botón para ver cómo se compone tu consumo y descubrí consejos para ahorrar en tu factura.
                </span>
              </div>
            </div>
          </div>
          <div className={"w-full text-center"}>
            <button
              type={"button"}
              className={`inline-flex justify-center px-4 py-1 text-xs font-small text-white bg-green-700 border border-transparent 
                          rounded-md hover:bg-green-600 focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2
                          focus-visible:ring-black-500 | disabled:opacity-40 disabled:cursor-default disabled:bg-green-600 | shadow-md`
                        }
              disabled={enableButton()} //Se habilita al haber al menos un elemento en la tabla de electro...
              onClick={handleClick}
            >
              VER TUS RESULTADOS
            </button>
          </div>
        </div>
        <div className={"hidden md:grid"}>
          <div className={"pl-6 text-green-700 text-lg font-medium text-left"}>
            CONSUMO BIMESTRAL ESTIMADO:
          </div>
          <Medidor />
        </div>
      </div>
      </div>
  );
};

export default Inputs
